import React from "react";

import Label from "./Label";
import { Controller } from "react-hook-form";

import styles from "./Field.module.scss";

const PairedFields = ({ keyFieldParams, valueFieldParams, description, label, control }) => {
  return (
    <div className={styles.formGroup}>
      <Label id={keyFieldParams.id} label={label} />
      <div className="row no-gutter">
        <div className={`${keyFieldParams.className || "col-12 col-xl-6 col-lg-6 col-md-6"}`}>
          <Controller
            name={keyFieldParams.id}
            control={control}
            defaultValue={keyFieldParams.defaultValue}
            rules={{ validate: (value) => (keyFieldParams.isRequired ? !!value : true) }}
            render={(props) => (
              <>
                <input
                  id={keyFieldParams.id}
                  name={keyFieldParams.name}
                  defaultValue={keyFieldParams.defaultValue}
                  disabled={!!keyFieldParams.disabled}
                  placeholder={keyFieldParams.placeholder}
                  type={keyFieldParams.type}
                  className={`${styles.field} form-control ${keyFieldParams.isInvalid}`}
                  onChange={(value) => props.onChange(value)}
                />
                {keyFieldParams.isInvalid && (
                  <div className="invalid-feedback">This field is required.</div>
                )}
              </>
            )}
          />
        </div>
        <div className={`${valueFieldParams.className || "col-12 col-xl-6 col-lg-6 col-md-6"}`}>
          <Controller
            name={valueFieldParams.id}
            control={control}
            defaultValue={valueFieldParams.defaultValue}
            rules={{ validate: (value) => (valueFieldParams.isRequired ? !!value : true) }}
            render={(props) => (
              <>
                <input
                  id={valueFieldParams.id}
                  name={valueFieldParams.name}
                  defaultValue={valueFieldParams.defaultValue}
                  disabled={!!valueFieldParams.disabled}
                  placeholder={valueFieldParams.placeholder}
                  type={valueFieldParams.type}
                  className={`${styles.field} form-control ${valueFieldParams.isInvalid}`}
                  onChange={(value) => props.onChange(value)}
                />
                {valueFieldParams.isInvalid && (
                  <div className="invalid-feedback">This field is required.</div>
                )}
              </>
            )}
          />
        </div>
      </div>
      <span className={`${styles.description} d-block mt-3`}>{description}</span>
    </div>
  );
};

export default PairedFields;
